import { render, staticRenderFns } from "./BranchEditTabSocial.vue?vue&type=template&id=f21ed646&"
import script from "./BranchEditTabSocial.vue?vue&type=script&lang=js&"
export * from "./BranchEditTabSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports